export default "__VITE_ASSET__Bqc7wvv9__"